import React from "react";
import { Box, Container, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, FreeMode, Pagination } from "swiper";

SwiperCore.use([Autoplay, FreeMode, Pagination]);

const BOOK_QUOTES: Array<{ quote: string; title: string; author: string }> = [
  {
    quote: "Every action you take is a vote for the person you want to become.",
    title: "Atomic Habits",
    author: "James Clear",
  },
  {
    quote: "You do not rise to the level of your goals. You fall to the level of your systems.",
    title: "Atomic Habits",
    author: "James Clear",
  },
  {
    quote: "Focus on being productive instead of busy.",
    title: "The 4-Hour Workweek",
    author: "Tim Ferriss",
  },
  {
    quote: "What gets scheduled gets done.",
    title: "Deep Work",
    author: "Cal Newport",
  },
  {
    quote: "Until we can manage time, we can manage nothing else.",
    title: "The Effective Executive",
    author: "Peter F. Drucker",
  },
  {
    quote: "Simplicity boils down to two steps: identify the essential, eliminate the rest.",
    title: "Essentialism",
    author: "Greg McKeown",
  },
  {
    quote: "You can do anything, but not everything.",
    title: "Getting Things Done",
    author: "David Allen",
  },
  {
    quote: "If you fail to plan, you are planning to fail.",
    title: "Productivity Principles",
    author: "Common Management Wisdom",
  },
  {
    quote: "The key is not to prioritize what's on your schedule, but to schedule your priorities.",
    title: "The 7 Habits of Highly Effective People",
    author: "Stephen R. Covey",
  },
  {
    quote: "Small disciplines repeated with consistency every day lead to great achievements.",
    title: "Time and Self-Management",
    author: "Habit-Based Leadership",
  },
];

export default function Advertisement() {
  return (
    <div className="ads-restaurant-frame">
      <Container>
        <Box className="ads-surface">
          <Box className="ads-quotes-backdrop" aria-hidden="true" />

          <Stack className="ads-content">
            <Box className="ads-eyebrow">Words that stay with you</Box>

            <Swiper
              className="ads-quotes-swiper"
              slidesPerView={"auto"}
              centeredSlides={false}
              spaceBetween={18}
              loop={true}
              speed={7000}
              freeMode={{
                enabled: true,
                momentum: false,
              }}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              pagination={{
                clickable: true,
              }}
            >
              {BOOK_QUOTES.map((q, idx) => (
                <SwiperSlide key={`${q.title}-${idx}`} className="ads-quote-slide">
                  <Box className="ads-quote-card">
                    <Box className="ads-quote-mark">“</Box>
                    <Box className="ads-quote-text">{q.quote}</Box>
                    <Box className="ads-quote-meta">
                      <span className="ads-quote-author">{q.author}</span>
                      <span className="ads-quote-dot">·</span>
                      <span className="ads-quote-title">{q.title}</span>
                    </Box>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>

            <Stack direction="row" spacing={1.5} className="ads-actions">
              <Link to="/products" className="ads-primary-btn">
                Browse books
              </Link>
              <Link to="/about" className="ads-secondary-btn">
                Learn more
              </Link>
            </Stack>
          </Stack>
        </Box>
      </Container>
    </div>
  );
}
